import React from "react";

import { Grid } from "@material-ui/core";

import {
  Labeled,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { CustomerAside } from "./CustomerAside";

const UserShowActions = ({ basePath }) => (
  <TopToolbar>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

const UserShowGrid = ({ record, ...props }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Labeled label="Firs Name">
          <TextField source="firstName" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={6}>
        <Labeled label="Last Name">
          <TextField source="lastName" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={6}>
        <Labeled label="Email">
          <TextField source="email" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={6}>
        <Labeled label="Phone">
          <TextField source="phone" />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export const CustomerShow = (props) => {
  return (
    <Show
      {...props}
      title="View User"
      actions={<UserShowActions />}
      aside={<CustomerAside {...props} />}
    >
      <SimpleShowLayout>
        <UserShowGrid />
      </SimpleShowLayout>
    </Show>
  );
};
